import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { fetchData } from "../helper/api.interceptor"; // ⬅ using your GET helper
import { useNavigate } from "react-router-dom";



const DiscountDetails = () => {
    const [discounts, setDiscounts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");

    const [showAddModal, setShowAddModal] = useState(false);
    const navigate = useNavigate();
    // Fetch Discounts
    const fetchDiscounts = async () => {
        try {
            const result = await fetchData.get(`discount/all`);

            if (result?.status_code === 200) {
                setDiscounts(result.result);
            } else {
                console.error("Failed to fetch discounts:", result?.message);
            }
        } catch (error) {
            console.error("Error fetching discounts:", error);
        }
    };

    useEffect(() => {
        fetchDiscounts();
    }, []);

    // Filtering
    const filteredDiscounts = discounts.filter((item) => {
        const query = searchQuery.trim().toLowerCase();

        return (
            item.discountId?.toLowerCase().includes(query) ||
            item.discountName?.toLowerCase().includes(query)
        );
    });

    // Pagination Logic
    const totalPages = Math.ceil(filteredDiscounts.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedDiscounts = filteredDiscounts.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    return (
        <div>
            {/* Title + Breadcrumb */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">Discount Details</h6>

                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li>-</li>
                    <li className="fw-medium">Discount Details</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto no-bg-position"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredDiscounts.length}>All</option>
                        </select>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <button
                            onClick={() => navigate("/discount_details/add")}
                            className="btn rounded-pill fw-medium d-flex align-items-center gap-2"
                            style={{
                                color: "rgb(255, 255, 255)",
                                border: "none",
                                backgroundColor: "rgb(84, 84, 84)",
                            }}
                        >
                            <Icon icon="mdi:plus" className="fs-5" />
                            Add New Discount
                        </button>
                    </div>
                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>Discount ID</th>
                                <th>Name</th>
                                <th>Start Date</th>
                                <th>Price</th>
                                <th>Percentage</th>
                                <th>End Date</th>
                                <th>Never Expires</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedDiscounts.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No discounts found.
                                    </td>
                                </tr>
                            ) : (
                                paginatedDiscounts.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{item.discountId}</td>
                                        <td>{item.discountName}</td>
                                        <td>{new Date(item.startDate).toLocaleDateString()}</td>
                                        <td>{item.discountPrice}</td>
                                        <td>{item.discountPercentage}%</td>
                                        <td>
                                            {item.neverExpires
                                                ? "—"
                                                : new Date(item.endDate).toLocaleDateString()}
                                        </td>
                                        <td>
                                            {item.neverExpires ? (
                                                <span className="text-success fw-bold">Yes</span>
                                            ) : (
                                                <span className="text-danger fw-bold">No</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="d-flex justify-content-end align-items-center gap-4 mt-3">
                        <button
                            className="btn btn-sm"
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                            }}
                        >
                            Prev
                        </button>

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <button
                            className="btn btn-sm"
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscountDetails;
